import { useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { SiteHeader } from './SiteHeader'
import { SiteFooter } from './SiteFooter'

/**
 * The frame every page sits in: fixed header, page, footer.
 *
 * The home page starts with a full-bleed dark hero that the header floats over,
 * so it gets no top padding. Every other page is pushed clear of the fixed bar.
 */
export function SiteLayout({ children }: { children: ReactNode }) {
  const { pathname } = useLocation()
  const isHome = pathname === '/'

  return (
    <div className="min-h-screen flex flex-col bg-bg">
      <SiteHeader />
      <main
        id="main"
        data-upbo-id="page-main"
        data-upbo-type="container"
        data-upbo-label="Page content"
        className={cn('flex-1', !isHome && 'pt-[68px]')}
      >
        {children}
      </main>
      <SiteFooter />
    </div>
  )
}
